import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ChassisEntityCollectionServiceBase } from '@kaiser-software/chassis-resource/src/services/chassis-entity-collection-service-base';
import { IAbstractEntity } from '@kaiser-software/chassis-resource/src/interfaces';
import { ResourceService } from '@kaiser-software/chassis-resource';

import { Form } from '../../interfaces/form-structure-interfaces';
import { FormComponent } from '../form/form.component';

@Component({
    selector: 'chassis-core-resource-form',
    templateUrl: './resource-form.component.html',
    styleUrls: ['./resource-form.component.scss']
})
export class ResourceFormComponent implements OnInit {
    @ViewChild(FormComponent) formComponent: FormComponent;

    @Input() entityName: string;

    @Input() entity: any = {};

    @Input() static = false;

    @Output() submit: EventEmitter<any> = new EventEmitter();

    protected entityService: ChassisEntityCollectionServiceBase<IAbstractEntity>;

    fields: Array<any>;

    structure: Form;

    constructor(
        protected resourceService: ResourceService,
    ) {
    }

    ngOnInit() {
        this.entityService = this.resourceService.get(this.entityName);

        this.entityService.getCreationForm().subscribe((form: Form) => {
            this.structure = form;
        });
    }

    saveEntity() {
        console.log('Resource form | Save');

        this.formComponent.save();
    }

    onSubmit(event) {
        console.log('Resource form | On submit: ', event);

        let observable;

        if (this.entity.hasOwnProperty('id')) {
            observable = this.entityService.update(event);
        } else {
            observable = this.entityService.add(event);
        }

        this.submit.emit(observable);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/resource-form/resource-form.component.ts